export default function checkRefundDate(date) {
  const now = new Date();
  const orderDate = new Date(date).getTime();
  const afterSevenDays = orderDate + 7 * 24 * 60 * 60 * 1000;

  const isRefundable = afterSevenDays - now < 0 ? false : true;

  return isRefundable;
}
